import React from 'react';
import './css/CustomerReviews.css';

// Reusing your standalone, modular layout components
import Navbar from './components/Navbar';
import Newsletter from './components/NewsLetter';
import Footer from './components/Footer';

// Reusing your global hero and banner background assets
import CustomerReviewsHeroBg from '../images/banner-customer.png';
import DownloadApp from './components/DownloadApp';

function CustomerReviews() {

    // Sample customer reviews
    // Replace these with Firebase/API data when available
    const reviews = [
        {
            id: 1,
            name: "Amit Sharma",
            rating: 5,
            service: "Home Cleaning",
            review:
                "Excellent service! The professional arrived on time and did a very thorough job. The entire booking process was simple and convenient."
        },
        {
            id: 2,
            name: "Priya Das",
            rating: 5,
            service: "AC & Appliance Service",
            review:
                "Very professional and reliable service. The technician quickly identified the issue with my AC and fixed it perfectly."
        },
        {
            id: 3,
            name: "Rahul Roy",
            rating: 4,
            service: "Plumbing",
            review:
                "The plumber was knowledgeable and completed the work efficiently. Booking through Fixovera was easy and hassle-free."
        },
        {
            id: 4,
            name: "Sneha Mukherjee",
            rating: 5,
            service: "Electrical Service",
            review:
                "Really happy with the service. The electrician was professional, polite and completed everything safely."
        },
        {
            id: 5,
            name: "Arindam Sen",
            rating: 5,
            service: "Painting & Renovation",
            review:
                "Great experience from booking to completion. The team was punctual and the quality of work was excellent."
        },
        {
            id: 6,
            name: "Neha Roy",
            rating: 4,
            service: "Pest Control",
            review:
                "The service was very convenient and the professional explained the entire process clearly. Good overall experience."
        }
    ];

    // Calculate overall rating
    const totalRating = reviews.reduce(
        (total, review) => total + review.rating,
        0
    );

    const averageRating = (
        totalRating / reviews.length
    ).toFixed(1);

    return (
        <div className="CustomerReviews-page-wrapper">

            {/* 1. Header Hero Section */}
            <section
                className="CustomerReviews-hero-section"
                style={{
                    backgroundImage: `url(${CustomerReviewsHeroBg})`
                }}
            >
                <Navbar />
            </section>

            {/* 2. Customer Reviews Section */}
            <section className="CustomerReviews-main-section">
                <div className="container">

                    {/* Section Header */}
                    <div className="row justify-content-center text-center mb-5">
                        <div className="col-lg-8">

                            <span className="CustomerReviews-section-mini-tag">
                                Customer Reviews
                            </span>

                            <h2 className="CustomerReviews-section-heading">
                                What Our Customers Say About Fixovera
                            </h2>

                            <p className="CustomerReviews-section-subtext mt-3">
                                Real experiences from customers who trust Fixovera
                                for reliable, professional and convenient household
                                services.
                            </p>

                            <div className="zigzag-border mx-auto mt-3"></div>

                        </div>
                    </div>

                    {/* Overall Rating */}
                    <div className="row justify-content-center mb-5">
                        <div className="col-lg-5 col-md-7">

                            <div className="CustomerReviews-overall-rating text-center">

                                <div className="CustomerReviews-rating-number">
                                    {averageRating}
                                </div>

                                <div className="CustomerReviews-stars">
                                    {[1, 2, 3, 4, 5].map((star) => (
                                        <span
                                            key={star}
                                            className={
                                                star <= Math.round(averageRating)
                                                    ? "star active"
                                                    : "star"
                                            }
                                        >
                                            ★
                                        </span>
                                    ))}
                                </div>

                                <p className="CustomerReviews-rating-text">
                                    Based on {reviews.length} customer reviews
                                </p>

                                <p className="CustomerReviews-rating-description">
                                    Trusted by customers for quality household
                                    services and professional service partners.
                                </p>

                            </div>

                        </div>
                    </div>

                    {/* Reviews Grid */}
                    <div className="row g-4">

                        {reviews.map((review) => (

                            <div
                                className="col-lg-4 col-md-6"
                                key={review.id}
                            >

                                <div className="CustomerReviews-card h-100">

                                    {/* Rating */}
                                    <div className="CustomerReviews-card-rating">
                                        {[1, 2, 3, 4, 5].map((star) => (
                                            <span
                                                key={star}
                                                className={
                                                    star <= review.rating
                                                        ? "star active"
                                                        : "star"
                                                }
                                            >
                                                ★
                                            </span>
                                        ))}
                                    </div>

                                    {/* Review */}
                                    <p className="CustomerReviews-card-review">
                                        "{review.review}"
                                    </p>

                                    {/* Customer */}
                                    <div className="CustomerReviews-card-user">

                                        <div className="CustomerReviews-user-avatar">
                                            {review.name.charAt(0)}
                                        </div>

                                        <div>
                                            <h5 className="CustomerReviews-user-name">
                                                {review.name}
                                            </h5>

                                            <p className="CustomerReviews-user-service">
                                                {review.service}
                                            </p>
                                        </div>

                                    </div>

                                </div>

                            </div>

                        ))}

                    </div>

                </div>
            </section>

            {/* Download App Section */}
            <DownloadApp />

            {/* Global Bottom Components */}
            <Newsletter />
            <Footer />

        </div>
    );
}

export default CustomerReviews;